<template>
  <BackupTrip :swal="sweetAlert"></BackupTrip>
</template>

<script>
/* eslint-disable */
import BackupTrip from '@/components/tripRequest/BackupTrip.vue';

export default {
  name: 'BackupRequest',
  data() {
    return {
      sweetAlert: this.$swal
    };
  },
  components: {
    BackupTrip
  }
};
</script>

<style scoped>
.trip-request {
  margin-top: 25px;
  margin-left: 25px;
  margin-right: 25px;
}
</style>
